import { render, staticRenderFns } from "./ContentUpdate.vue?vue&type=template&id=4c246206"
import script from "./ContentUpdate.vue?vue&type=script&lang=js"
export * from "./ContentUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports